/* Media load guard only. Native routes/forms/purchase handlers are unchanged. */
(() => {
  if (window.terplaxCollectionCardsInitialized) return;
  window.terplaxCollectionCardsInitialized = true;
  // Measure collection underlay independently of Dawn's breakpoint-cached height.
  let observedHeader;
  const syncHeaderHeight = () => {
    if (!document.querySelector('.tplx-collection-hero')) return;
    const height = observedHeader?.getBoundingClientRect().height;
    if (height > 0) document.documentElement.style.setProperty('--tplx-collection-nav-height', `${height}px`);
  };
  const headerObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(syncHeaderHeight) : null;
  const observeHeader = () => {
    if (!document.querySelector('.tplx-collection-hero')) return;
    const header = document.querySelector('.section-header');
    if (observedHeader !== header) {
      headerObserver?.disconnect();
      observedHeader = header;
      if (header) headerObserver?.observe(header);
    }
    syncHeaderHeight();
  };
  observeHeader();
  document.addEventListener('shopify:section:load', observeHeader);
  if (!headerObserver) window.addEventListener('resize', syncHeaderHeight, { passive: true });
  const initialize = (scope) => {
    scope.querySelectorAll('[data-collection-media]').forEach((media) => {
      if (media.dataset.mediaInitialized) return;
      media.dataset.mediaInitialized = 'true';
      const primary = media.querySelector('.tplx-collection-media__primary');
      const white = media.querySelector('.tplx-collection-media__white');
      if (!primary || !white) return;
      const whiteReady = () => media.toggleAttribute('data-white-ready', white.complete && white.naturalWidth > 0);
      const primaryState = () => media.toggleAttribute('data-primary-failed', primary.complete && primary.naturalWidth === 0);
      white.addEventListener('load', whiteReady, { once: true });
      white.addEventListener('error', whiteReady, { once: true });
      primary.addEventListener('load', primaryState, { once: true });
      primary.addEventListener('error', primaryState, { once: true });
      whiteReady(); primaryState();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  /* Dawn replaces product cards after native filter/sort updates. */
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver((changes) => {
    for (const change of changes) for (const node of change.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches('[data-collection-media]')) initialize(node.parentElement);
      else initialize(node);
    }
  }).observe(main, { childList: true, subtree: true });
})();

/* Collection quantity steps only; procurement submission stays in its owner. */
(() => {
  if (window.terplaxCollectionQuantityStepsInitialized) return;
  window.terplaxCollectionQuantityStepsInitialized = true;
  const quantitySelector = 'input[data-collection-quantity][name="quantity"]';
  const formSelector = '.tplx-flavor__purchase[data-procurement-add],.tp-shop-browser__purchase[data-procurement-add]';
  const invalidSteps = new WeakSet();
  const readQuantity = (input) => {
    const text = input.value;
    const number = Number(text);
    const minimum = Math.max(1, Number(input.min) || 1);
    const maximum = Math.min(9999, Number(input.max) || 9999);
    return /^\d{1,4}$/.test(text) && number >= minimum && number <= maximum && !input.validity.badInput
      ? { number, minimum, maximum } : null;
  };
  const clearStepError = (input) => {
    if (!invalidSteps.has(input)) return;
    input.setCustomValidity('');
    invalidSteps.delete(input);
  };
  const syncButtons = (input) => {
    const form = input.closest(formSelector);
    if (!form) return;
    const value = readQuantity(input);
    form.querySelectorAll('button[data-collection-quantity-step]').forEach((button) => {
      const delta = Number(button.dataset.collectionQuantityStep);
      button.disabled = input.disabled || input.readOnly || Boolean(value &&
        (delta === -1 ? value.number <= value.minimum : value.number >= value.maximum));
    });
  };
  const initialize = (scope) => {
    if (scope.matches?.(quantitySelector)) syncButtons(scope);
    scope.querySelectorAll(quantitySelector).forEach(syncButtons);
  };
  initialize(document);
  for (const type of ['input', 'change']) {
    document.addEventListener(type, (event) => {
      const input = event.target;
      if (!input.matches?.(quantitySelector) || !input.closest(formSelector)) return;
      clearStepError(input);
      syncButtons(input);
    });
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver((changes) => {
    for (const change of changes) for (const node of change.addedNodes) {
      if (node.nodeType === 1) initialize(node);
    }
  }).observe(main, { childList: true, subtree: true });
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('button[data-collection-quantity-step]');
    if (!button || button.disabled) return;
    const form = button.closest(formSelector);
    const input = form?.querySelector(quantitySelector);
    const delta = Number(button.dataset.collectionQuantityStep);
    if (!input || input.disabled || input.readOnly || (delta !== -1 && delta !== 1)) return;
    const value = readQuantity(input);
    if (!value) {
      input.setCustomValidity(input.dataset.collectionQuantityError);
      invalidSteps.add(input);
      input.reportValidity();
      return;
    }
    clearStepError(input);
    input.value = String(Math.min(value.maximum, Math.max(value.minimum, value.number + delta)));
    syncButtons(input);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
